// biens-immobs.model.ts
import { Agencies } from "./agencies";

export class BiensImmobs {
    id: number;
    name: string;
    nameArabe: string;              // Arabic name
    nameAnglais: string;            // NEW: English name
    description: string;
    agencyName: Agencies[];
    prix: number;
    imageUrl: string;
    status: string;
    categorie: string;
    categoryList: string[];
    promoTitle: string;
    promoImg: string;
    type: string;
    role: string;
    videoUrlBien: string;
    nomCommercial: string;
    nomCommercialArabe: string;     // NEW: Arabic commercial name
    numCommercial: string;
    emailCommercial: string;
}